"use client"

import { Link } from "react-router-dom"
import { useForm } from "react-hook-form"
import Input from "../../components/form/input"
import { useState } from "react"
import { useTranslations } from "../../translations"

const Step3 = ({ defaultValues, next, step }) => {
  const { handleSubmit, watch, control } = useForm({
    defaultValues: {
      ...defaultValues,
    },
  })
  const [requiredCode, setRequiredCode] = useState("")
  const [requiredEmail, setRequiredEmail] = useState("")
  const [requiredPassword, setRequiredPassword] = useState("")
  const { t } = useTranslations()

  const onSubmit = (data) => {
    if (!data.code) {
      setRequiredCode(t("accessCodeRequired"))
      return
    }
    if (!data.email) {
      setRequiredEmail(t("emailRequired"))
      return
    }
    if (!data.password) {
      setRequiredPassword(t("passwordRequired"))
      return
    }
    next(data, step)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Link to={"/"}><img src="/assets/img/landing-images/MiABC-33.png" alt="MiABC Logo" className="auth-logo" /></Link>
      <h3 className="title">{t("createAccount")}</h3>
      <div id="input-div-code" className="input-div one mb-0">
        <div className="i">
          <i className="fas fa-key"></i>
        </div>
        <Input
          control={control}
          name="code"
          type="text"
          id="code"
          required
          inputId="input-div-code"
          label={t("accessCode")}
        />
      </div>
      <div className="text-danger mb-2">{requiredCode}</div>
      <div id="input-div-email" className="input-div one mb-0">
        <div className="i">
          <i className="fas fa-user"></i>
        </div>
        <Input
          control={control}
          name="email"
          type="email"
          id="email"
          required
          inputId="input-div-email"
          label={t("nameEmail")}
        />
      </div>
      <div className="text-danger mb-2">{requiredEmail}</div>
      <div id="input-div-password2" className="input-div pass mb-0">
        <div className="i">
          <i className="fas fa-lock"></i>
        </div>
        <Input
          control={control}
          name="password"
          type="password"
          id="password"
          inputId="input-div-password2"
          required
          label={t("password")}
        />
      </div>
      <div className="text-danger mb-2">{requiredPassword}</div>
      <input type="submit" className="btn" value={t("next")} />
      <Link to="/register/step2" className="btn-2">
        {t("back")}
      </Link>
      <div className="mt-3">
        <Link to="/login" className="text-link-1">
          {t("alreadyHaveAccount")} <strong>{t("signIn")}</strong>
        </Link>
      </div>
      <p className="text-link-1 mt-3">
        {t("privacyRegisterText")}{" "}
        <Link to="/privacy" target="_blank" className="d-inline">
          {t("privacyPolicy")}
        </Link>
      </p>
    </form>
  )
}

export default Step3
